export const STAGES = {
  INITIAL: 'initial',
}
